import { WithChildren } from '@/_metronic/helpers'
import { createContext, FC, useContext, useState } from 'react'
import { FilterReportBookingType, initialFilter } from './_models'

type ProductQueryRequestContextProps = {
  state: FilterReportBookingType
  updateState: (updates: Partial<FilterReportBookingType>) => void
}

const initialQueryRequest = {
  state: initialFilter,
  updateState: () => {},
}

const QueryRequestContext = createContext<ProductQueryRequestContextProps>(initialQueryRequest)

const QueryRequestProvider: FC<WithChildren> = ({children}) => {
  const [state, setState] = useState<FilterReportBookingType>(initialQueryRequest.state)

  const updateState = (updates: Partial<FilterReportBookingType>) => {
    const updatedState = {...state, ...updates} as FilterReportBookingType
    setState(updatedState)
  }

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export { QueryRequestProvider, useQueryRequest }

